var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.values, function (value) {
      return _c("dash-attempt", {
        key: value.index,
        attrs: {
          attemptId: value.attemptId,
          firstItem: value.firstItem,
          label: value.label,
          description: _vm.$t(value.description, { amount: value.amount }),
          thirdLine: value.thirdLine,
          textBadge: value.textBadge,
          trailingText: _vm.$t("details"),
          color: value.color,
          eventProps: _vm.historyEvent,
        },
        on: { handleClick: () => _vm.$emit("item", value.data) },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }